import AppDispatcher from "../dispatcher/AppDispatcher"
import { EventEmitter } from "events"
import Constants from "../constants/Constants"
import assign from "object-assign"
import Member from "../vo/Member"
import Paid from "../vo/Paid"


var CHANGE_EVENT = "change" // chenge evnetを定数にする
var GET_PAID_LIST = "paid_list" // chenge evnetを定数にする
var GET_LIST = "list_loaded" // chenge evnetを定数にする

var _member = new Member()
var _paid_lsit = []
var _list = []


var setDetail = (item) =>{
  _member = MemberStore.createRecord(item)
}

var setPaidList = (items) =>{
  var _list = []
  items.map((item) =>{
    _list.push(MemberStore.createPaidRecord(item))
  })
  _paid_lsit = _list
}

var setList = (items) =>{
  _list = [];
  items.map((item) =>{
    _list.push(MemberStore.createRecord(item))
  })
}

var MemberStore = assign({},EventEmitter.prototype,{

  getDetail(){
    return _member
  },

  getList(){
    return _list
  },


  getPaidList(){
    return _paid_lsit
  },

  createRecord(item){

    return new Member(
    {
      id: item.id,
      name: item.name,
      customer:item.customer,
      picture:item.picture
    })
  },
  createPaidRecord(item){

    return new Paid(
    {
      created: item.created,
      amount: item.amount,
      paid: item.paid
    })
  },



  emitChange(str =  CHANGE_EVENT){ // 何かアクションがあったことを知らせる
    this.emit(str)
  },

  addChangeListener(callback,str =  CHANGE_EVENT){ // リスナーに追加
    this.on(str, callback)
  },

  removeChangeListener(callback,str =  CHANGE_EVENT){ // リスナーから削除
    this.removeListener(str, callback)
  },

})

AppDispatcher.register((action)=>{

  switch(action.actionType){ // actionTypeでswitchする

    case Constants.MEMBER_GET_DETAIL:
      setDetail(action.detail);
      MemberStore.emitChange()
      break;
    case Constants.MEMBER_GET_PAID_LIST:
      setPaidList(action.list);
      MemberStore.emitChange(GET_PAID_LIST)
      break;
    case Constants.MEMBER_GET_LIST:
    setList(action.list);
    MemberStore.emitChange(GET_LIST)
    break;

    default:


      // no
  }
})
export default MemberStore



// WEBPACK FOOTER //
// ./src/stores/MemberStore.js